/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateSmsTemplateRequest,
  ProblemDetails,
  ResolveSmsTemplateRequest,
  ResolvedSmsTemplateResponse,
  SmsTemplateResponse,
  UpdateSmsTemplateRequest,
  ValidationProblemDetails,
} from '../models/index';
import {
    CreateSmsTemplateRequestFromJSON,
    CreateSmsTemplateRequestToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    ResolveSmsTemplateRequestFromJSON,
    ResolveSmsTemplateRequestToJSON,
    ResolvedSmsTemplateResponseFromJSON,
    ResolvedSmsTemplateResponseToJSON,
    SmsTemplateResponseFromJSON,
    SmsTemplateResponseToJSON,
    UpdateSmsTemplateRequestFromJSON,
    UpdateSmsTemplateRequestToJSON,
    ValidationProblemDetailsFromJSON,
    ValidationProblemDetailsToJSON,
} from '../models/index';

export interface CreateSmsTemplateOperationRequest {
    createSmsTemplateRequest: CreateSmsTemplateRequest;
}

export interface DeleteSmsTemplateRequest {
    id: string;
}

export interface ResolveSmsTemplateOperationRequest {
    id: string;
    resolveSmsTemplateRequest: ResolveSmsTemplateRequest;
}

export interface UpdateSmsTemplateOperationRequest {
    id: string;
    updateSmsTemplateRequest: UpdateSmsTemplateRequest;
}

/**
 * SmsTemplatesApi - interface
 * 
 * @export
 * @interface SmsTemplatesApiInterface
 */
export interface SmsTemplatesApiInterface {
    /**
     * 
     * @param {CreateSmsTemplateRequest} createSmsTemplateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmsTemplatesApiInterface
     */
    createSmsTemplateRaw(requestParameters: CreateSmsTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SmsTemplateResponse>>;

    /**
     */
    createSmsTemplate(requestParameters: CreateSmsTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SmsTemplateResponse>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmsTemplatesApiInterface
     */
    deleteSmsTemplateRaw(requestParameters: DeleteSmsTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deleteSmsTemplate(requestParameters: DeleteSmsTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmsTemplatesApiInterface
     */
    getAllSmsTemplatesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SmsTemplateResponse>>>;

    /**
     */
    getAllSmsTemplates(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SmsTemplateResponse>>;

    /**
     * 
     * @param {string} id 
     * @param {ResolveSmsTemplateRequest} resolveSmsTemplateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmsTemplatesApiInterface
     */
    resolveSmsTemplateRaw(requestParameters: ResolveSmsTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResolvedSmsTemplateResponse>>;

    /**
     */
    resolveSmsTemplate(requestParameters: ResolveSmsTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResolvedSmsTemplateResponse>;

    /**
     * 
     * @param {string} id 
     * @param {UpdateSmsTemplateRequest} updateSmsTemplateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmsTemplatesApiInterface
     */
    updateSmsTemplateRaw(requestParameters: UpdateSmsTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SmsTemplateResponse>>;

    /**
     */
    updateSmsTemplate(requestParameters: UpdateSmsTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SmsTemplateResponse>;

}

/**
 * 
 */
export class SmsTemplatesApi extends runtime.BaseAPI implements SmsTemplatesApiInterface {

    /**
     */
    async createSmsTemplateRaw(requestParameters: CreateSmsTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SmsTemplateResponse>> {
        if (requestParameters['createSmsTemplateRequest'] == null) {
            throw new runtime.RequiredError(
                'createSmsTemplateRequest',
                'Required parameter "createSmsTemplateRequest" was null or undefined when calling createSmsTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/settings/sms-templates`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSmsTemplateRequestToJSON(requestParameters['createSmsTemplateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SmsTemplateResponseFromJSON(jsonValue));
    }

    /**
     */
    async createSmsTemplate(requestParameters: CreateSmsTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SmsTemplateResponse> {
        const response = await this.createSmsTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteSmsTemplateRaw(requestParameters: DeleteSmsTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteSmsTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/settings/sms-templates/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteSmsTemplate(requestParameters: DeleteSmsTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteSmsTemplateRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getAllSmsTemplatesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SmsTemplateResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/settings/sms-templates`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SmsTemplateResponseFromJSON));
    }

    /**
     */
    async getAllSmsTemplates(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SmsTemplateResponse>> {
        const response = await this.getAllSmsTemplatesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async resolveSmsTemplateRaw(requestParameters: ResolveSmsTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResolvedSmsTemplateResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling resolveSmsTemplate().'
            );
        }

        if (requestParameters['resolveSmsTemplateRequest'] == null) {
            throw new runtime.RequiredError(
                'resolveSmsTemplateRequest',
                'Required parameter "resolveSmsTemplateRequest" was null or undefined when calling resolveSmsTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/settings/sms-templates/{id}/resolve`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResolveSmsTemplateRequestToJSON(requestParameters['resolveSmsTemplateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResolvedSmsTemplateResponseFromJSON(jsonValue));
    }

    /**
     */
    async resolveSmsTemplate(requestParameters: ResolveSmsTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResolvedSmsTemplateResponse> {
        const response = await this.resolveSmsTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateSmsTemplateRaw(requestParameters: UpdateSmsTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SmsTemplateResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateSmsTemplate().'
            );
        }

        if (requestParameters['updateSmsTemplateRequest'] == null) {
            throw new runtime.RequiredError(
                'updateSmsTemplateRequest',
                'Required parameter "updateSmsTemplateRequest" was null or undefined when calling updateSmsTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/settings/sms-templates/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSmsTemplateRequestToJSON(requestParameters['updateSmsTemplateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SmsTemplateResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateSmsTemplate(requestParameters: UpdateSmsTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SmsTemplateResponse> {
        const response = await this.updateSmsTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
